import {theme} from "@/theme"
import {
  Dimension,
  Measure,
  MemberDimension,
  MemberSnapshotCube,
  MemberSnapshotDimension,
  SuperScoreCube,
  SuperScoreDimension,
} from "@/cube"

export type MeasureSettings = {readonly [key in Measure]?: any}

export const measureSettings: MeasureSettings = {
  [MemberSnapshotCube.averageTotalAssetsOwned]: {
    type: "money",
  },
  [MemberSnapshotCube.totalAssetsOwned]: {
    type: "money",
  },
  [MemberSnapshotCube.averageSalary]: {
    type: "money",
  },
  [MemberSnapshotCube.averageLifeInsuranceCover]: {
    type: "money",
  },
  [MemberSnapshotCube.averageInsurancePremium]: {
    type: "money",
  },
  [MemberSnapshotCube.averageAdministrationFeeAmount]: {
    type: "money",
  },
  [MemberSnapshotCube.averageInvestmentFeeAmount]: {
    type: "money",
  },
  [SuperScoreCube.averageSuperScore]: {
    valueAxis: {max: 5, min: 0, strictMinMax: true},
  },
  [SuperScoreCube.averageBeneficiaryScore]: {
    valueAxis: {max: 5, min: 0},
  },
  [MemberSnapshotCube.countMembers]: {
    valueAxis: {min: 0},
  },
}

interface DimensionSettings {
  color?: string
  isDownPositive?: boolean
}
const t = theme()

const dimensionAndValueMap: {
  [k in Dimension]?: Record<string, DimensionSettings>
} = {
  [MemberSnapshotDimension.beneficiaryNominationType]: {
    "Binding": {color: t.primaryColor},
    "Legal Rep": {color: t.primaryColor},
    "Non-binding": {color: t.secondaryColor},
    "Non-lapsing": {color: t.secondaryColor},
    "Spouse": {color: t.secondaryColor},
    "None": {color: t.negativeColor, isDownPositive: true},
  },
  [SuperScoreDimension.lifeInsuranceIndicatorResult]: {
    None: {color: t.alt2Color, isDownPositive: true},
  },
  [SuperScoreDimension.projectedRetirementStandardName]: {
    Inadequate: {color: t.negativeColor, isDownPositive: true},
  },
  [MemberDimension.expiredBeneficiaryNominated]: {
    Yes: {color: t.negativeColor, isDownPositive: true},
    No: {color: t.positiveColor},
  },
  [MemberSnapshotDimension.insuranceCoverType]: {
    None: {color: t.negativeColor, isDownPositive: true},
  },
  [MemberSnapshotDimension.noLifeInsurance]: {
    No: {color: t.positiveColor},
    Yes: {color: t.negativeColor, isDownPositive: true},
  },
}

const valueMap: Record<string, DimensionSettings | undefined> = {
  "No": {color: t.warningColor, isDownPositive: true},
  "None": {color: t.negativeColor},
  "On target": {color: t.positiveColor},
  "Under insured": {color: t.negativeColor, isDownPositive: true},
  "Over insured": {color: t.warningColor, isDownPositive: true},
  "Modest": {color: t.warningColor},
  "Comfortable": {color: t.positiveColor},
  "Aspirational": {color: t.primaryColor},
  0: {color: t.negativeColor, isDownPositive: true},
}
export function dimensionSettings(dimension: Dimension, value: string): DimensionSettings {
  return dimensionAndValueMap[dimension]?.[value] ?? valueMap[value] ?? {}
}
